import { DateHelper } from '../util/dateHelper';
import { BaseModel } from './baseModel';
import { Deserializable } from './deserializable';


export class DevicePilomatActivation extends BaseModel implements Deserializable {
  
  serial : string;
  activationDate : Date;
  activationDateFriendly : string;

  deserialize(input: any) {
    super.deserialize(input);
    Object.assign(this, input);
    this.activationDateFriendly = DateHelper.formatDateFriendly(this.activationDate);
    
    return this;
  }
}
